// extracted by mini-css-extract-plugin
export default {"container":"Aj-z","blurb":"Bj-z","links":"Cj-z"};